export const nativeCallBackMethod = (message: any) => {
  return new Promise((resolve, reject) => {
    window.handleResponseForDeviceInfo = function (response) {
      resolve(response);
    };
    const webkit = (window as any).webkit;
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.customHandler
    ) {
      webkit.messageHandlers.customHandler.postMessage(message);
    }
  });
};

export const nativeCallBackMethodForAppReview = (message: any) => {
  return new Promise((resolve, reject) => {
    window.handleResponseForRequestAppReview = function (response) {
      resolve(response);
    };
    const webkit = (window as any).webkit;
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.customHandler
    ) {
      webkit.messageHandlers.customHandler.postMessage(message);
    }
  });
};

export const nativeCallBackMethodForAppPermission = (message: any) => {
  return new Promise((resolve, reject) => {
    window.handleResponseForRequestAppPermission = function (response) {
      resolve(response);
    };
    const webkit = (window as any).webkit;
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.customHandler
    ) {
      webkit.messageHandlers.customHandler.postMessage(message);
    }
  });
};

export const nativeCallBackMethodForCamera = (message: any) => {
  return new Promise((resolve, reject) => {
    window.handleResponseForCamera = function (response) {
      resolve(response);
    };
    const webkit = (window as any).webkit;
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.customHandler
    ) {
      webkit.messageHandlers.customHandler.postMessage(message);
    }
  });
};

export const nativeCallBackMethodForNotification = (message: any) => {
  return new Promise((resolve, reject) => {
    window.handleResponseForNotification = function (response) {
      resolve(response);
    };
    const webkit = (window as any).webkit;
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.customHandler
    ) {
      webkit.messageHandlers.customHandler.postMessage(message);
    }
  });
};

export const nativeCallBackMethodForLocation = (message: any) => {
  return new Promise((resolve, reject) => {
    window.handleResponseForLocation = function (response) {
      resolve(response);
    };
    const webkit = (window as any).webkit;
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.customHandler
    ) {
      webkit.messageHandlers.customHandler.postMessage(message);
    }
  });
};

export const nativeCallBackMethodForStorage = (message: any) => {
  return new Promise((resolve, reject) => {
    window.handleResponseForStorage = function (response) {
      resolve(response);
    };
    const webkit = (window as any).webkit;
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.customHandler
    ) {
      webkit.messageHandlers.customHandler.postMessage(message);
    }
  });
};

export const nativeCallBackMethodForMicrophone = (message: any) => {
  return new Promise((resolve, reject) => {
    window.handleResponseForMicrophone = function (response) {
      resolve(response);
    };
    const webkit = (window as any).webkit;
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.customHandler
    ) {
      webkit.messageHandlers.customHandler.postMessage(message);
    }
  });
};

export const downloadPDFFromBase64 = (message: any) => {
  return new Promise((resolve, reject) => {
    window.handleResponseForBase64 = function (response) {
      resolve(response);
    };
    const webkit = (window as any).webkit;
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.customHandler
    ) {
      webkit.messageHandlers.customHandler.postMessage(message);
    }
  });
};
